import React from 'react';
import { Text, View, Image } from '@react-pdf/renderer';

interface BrandFooterProps {
  bottom?: number;
  component?: 'ChangeOrdersPDF' | 'ContinuationSheetPDF' | 'other'; // Add component identifier
  imageMarginTop?: number; // Allow custom margin-top for image
}

export function BrandFooter({
  bottom,
  component,
  imageMarginTop
}: BrandFooterProps): React.ReactElement {
  // Apply specific margin-top for image
  const imageStyle = {
    width: 50, 
    marginRight: 3,
    // ...(component === 'ChangeOrdersPDF' && { marginTop: imageMarginTop || 2 }), // Default to 2 if not specified
    // ...(imageMarginTop && component !== 'ChangeOrdersPDF' && { marginTop: imageMarginTop || 11 }) // Allow custom marginTop for any component
  };

  return (
    <View fixed style={{
      position: 'absolute',
      bottom: bottom ?? 20,
      left: 20,
      right: 20,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}>
      <View style={{
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 10
      }}>
        <Image src='/img/PAYearned-logo-long.png' style={imageStyle} />
        <Text>Easy and accurate Pay Apps by PAYearned.com</Text>
      </View>
      <Text fixed
        style={{
          fontSize: 12,          
        }}
        render={({ pageNumber, totalPages }): string =>
          component === 'ChangeOrdersPDF'
            ? `Change Order Page ${pageNumber} of ${totalPages}`
            : component === 'ContinuationSheetPDF' ? `Continuation Sheet Page ${pageNumber} of ${totalPages}` 
              : ''
        }
      />
    </View>
  );
}
